import PortalService from '@/services/portal.service';

export const role = {
  namespaced: true,

  state: {
    rolesAvailable: {}
  },

  actions: {
    async initRolesAvailable({ commit }) {
      const rolesAvailable = await PortalService.getRoles();
      commit('updateRolesAvailable', rolesAvailable);
    }
  },

  mutations: {
    updateRolesAvailable(state, rolesAvailable) {
      state.rolesAvailable = rolesAvailable;
    }
  },

  getters: {
    rolesAvailable(state) {
      return state.rolesAvailable;
    }
  }
};
